import React, { useState } from 'react';
import { useAuth } from '../../api/auth/store'; // Import the useAuth hook and AuthProps type
import Label from '../../components/Label';

interface DeviceVerificationProps {
  onVerificationSuccess: () => void;
  onVerificationError: (error: string) => void;
}

const DeviceVerification: React.FC<DeviceVerificationProps> = ({
  onVerificationSuccess,
  onVerificationError,
}) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState('');
  const [message, setMessage] = useState('A verification code has been sent to your email.');
  const [verified, setVerified] = useState(false)
  const { verifyDeviceOtp } = useAuth((state) => state); // Get the verifyDeviceOtp action from the store and explicitly type state

  const handleOtpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOtp(event.target.value);
  };

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      const code = await verifyDeviceOtp(otp); // Call the action from the store

      if (code === "200") {
        setMessage('Device verified successfully!');
        setVerified(true)
        setTimeout(() => {
          onVerificationSuccess();
        }, 2000)
      } else if (code === "invalid_otp") {
        setError('Invalid OTP code. Please try again.');
        onVerificationError('Invalid OTP code.');
      } else {
        //setMessage('Input valid OTP code.');
        onVerificationError('Invalid OTP code.');
      }
    } catch (error) {
      setMessage('An error occurred during verification.');
      onVerificationError('An error occurred during verification.');
      console.error('Device verification error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
      <h4 style={{ textAlign: 'center' }}>New Device Detected</h4>
      <p>{message}</p>
      {!verified && <input
        type="text"
        placeholder="Enter OTP"
        value={otp}
        onChange={handleOtpChange}
        disabled={loading}
      />}
      {!verified && <button onClick={handleSubmit} disabled={loading}>
        {loading ? 'Verifying...' : 'Verify Device'}
      </button>}
      {err && <Label fontWeight='normal' size='small' padding='0' color='red'>{err}</Label>}
      {verified && <Label fontWeight='normal'>Logging in...</Label>}
    </div>
  );
};

export default DeviceVerification;
